import { jsxs, jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { useState, useCallback, useEffect } from "react";
import Button from "../../inputs/Button/Button.js";
const TabNavigation = ({
  classes,
  className,
  variant = "primary",
  direction = "horizontal",
  tabActions,
  onChange,
  currentTab,
  autoSelect = false,
  toggle = false
}) => {
  const { themeClasses } = useThemePresetClasses("TabNavigation", classes, className, {
    variant,
    modifier: direction
  });
  const [current, setCurrent] = useState(
    !!currentTab ? currentTab : autoSelect ? tabActions[0] : void 0
  );
  const handleTabChange = useCallback(
    (tab) => {
      var _a;
      (_a = tab.onClick) == null ? void 0 : _a.call(tab);
      if (toggle && (current == null ? void 0 : current.id) === tab.id) {
        onChange == null ? void 0 : onChange(void 0);
        setCurrent(void 0);
        return;
      }
      onChange == null ? void 0 : onChange(tab);
      setCurrent(tab);
    },
    [current == null ? void 0 : current.id, onChange, toggle]
  );
  useEffect(() => {
    if (autoSelect) return;
    setCurrent(currentTab);
  }, [autoSelect, currentTab]);
  return /* @__PURE__ */ jsxs("div", { className: cn(themeClasses == null ? void 0 : themeClasses.root), children: [
    variant !== "underlined" && tabActions.map((action, index) => {
      var _a, _b;
      let btnVariant = variant;
      if ((current == null ? void 0 : current.id) === action.id) {
        btnVariant = variant === "primary" ? "secondary" : "primary";
      }
      return /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => handleTabChange == null ? void 0 : handleTabChange(action),
          variant: btnVariant,
          size: action.size,
          className: cn(themeClasses == null ? void 0 : themeClasses.tab, (_a = action.styles) == null ? void 0 : _a.className, {
            "h-[56px] !w-[64px] rounded-md px-2 py-3": direction === "horizontal",
            "h-[43px] w-full p-2": direction === "vertical"
          }),
          classes: {
            ...(_b = action.styles) == null ? void 0 : _b.classes,
            root_primary: "bg-accentBrand-800",
            root_secondary: "bg-tabNavSecondary"
          },
          "aria-label": action["aria-label"],
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: cn("flex gap-1", {
                "flex-col items-center justify-between": direction === "horizontal",
                "flex-row": direction === "vertical"
              }),
              "aria-label": action["aria-label"],
              children: [
                action.icon,
                !!action.label && /* @__PURE__ */ jsx(
                  "span",
                  {
                    className: "text-xs font-semibold",
                    "aria-label": action["aria-label"],
                    children: action.label
                  }
                )
              ]
            }
          )
        },
        action.id
      );
    }),
    variant === "underlined" && /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "flex h-10 w-full items-center justify-around border-b border-[rgba(255,255,255,0.16)]",
          themeClasses == null ? void 0 : themeClasses.underlinedWrapper
        ),
        children: tabActions.map((option) => /* @__PURE__ */ jsx(
          "button",
          {
            className: cn("flex h-full w-[90px] justify-center pb-[1px] pt-1.5", themeClasses == null ? void 0 : themeClasses.tabButton),
            onClick: () => handleTabChange == null ? void 0 : handleTabChange(option),
            "aria-label": option["aria-label"],
            children: /* @__PURE__ */ jsx(
              "span",
              {
                className: cn(
                  "flex h-full w-fit items-center justify-center whitespace-nowrap border-b-2 border-b-transparent text-xs leading-4 text-content-base transition-[font-weight,border-color] will-change-contents",
                  {
                    "!border-b-accentBrand-400 font-bold": (current == null ? void 0 : current.id) === option.id
                  }
                ),
                "aria-label": option["aria-label"],
                children: option.label
              }
            )
          },
          option.id
        ))
      }
    )
  ] });
};
const TabNavigation$1 = TabNavigation;
export {
  TabNavigation$1 as default
};
